<script>
import common from '@/scripts/common';

function createCheckBox(h, c, i, vm) {
    const classes = 'item-check-box ' + getContainerClasses(i, vm.selectedItem);
    //const onClickEvent = (e) => vm.itemClicked(i);

    // return (
    //     <div className={classes} onClick={onClickEvent}>
    //         <div class={getCheckboxClass(c)}></div>
    //         {c.title}
    //     </div>
    // );

    return h(
        'div',
        {
            attrs: {
            class: classes,
            tabindex: 2
            },
            on: {
	            click: (e) => vm.itemClicked(i),
        	    keydown: vm.checkboxKeyPressed
}
        },
        [
            h('div', {
                class: getCheckboxClass(c)
            }),
            c.title
        ]
    );
}

/* eslint no-unused-vars: 'off' */
export default {
    model: {
        isEnabled: 'true'
    },
    //:bind="control1Levels" v-model="selectedLevels.control1"
    //props: ["bind", "value"]
    props: ['levels', 'selections'],
    computed: {},
    render(h) {
        const vm = this;
        const checkboxes = vm.listItems.map((c, i) =>
            createCheckBox(h, c, i, vm)
        );
        const parentClasses = 'parent-check-box' + getContainerClasses(-1);
        const headerCheckbox = h('div', {
            attrs: {
                class: getCheckboxClass(vm.parent)
            }
        });

        const header = h(
            'div',
            {
                attrs: {
                    class: parentClasses,
                    tabindex: 2
                },
                on: {
                    click: (e) => vm.itemClicked(-1),
                    keydown: vm.checkboxKeyPressed
                }
            },
            [headerCheckbox, vm.parent.title]
        );

        vm.allCheckboxes = [header, ...checkboxes];

        return h(
            'div',
            {
                attrs: {
                    class: 'checkbox-list form-control',
                    tabindex: 0
                },
                on: {
                    keydown: vm.boxKeyPressed
                }
            },
            vm.allCheckboxes
        );
    },
    data() {
        var vm = this;
        var listItems = createListItems(vm.levels, vm.selections);
        return {
            listItems: listItems,
            parent: {
                isChecked: areAllChecked(listItems),
                title: '(Select All)'
            },
            selectedItem: -1,
            allCheckboxes: []
        };
    },
    methods: {
        boxKeyPressed,
        checkboxKeyPressed,
        keyHandler,
        itemClicked,
        updateModel
    }
};

function getContainerClasses(itemIndex, selectedItem) {
    return {
        'input-container': true,
        'blue-active': selectedItem === itemIndex
    };
}
function getCheckboxClass(item) {
    if (item.isChecked === null) return 'glyphicon glyphicon-stop';
    if (item.isChecked === true) return 'glyphicon glyphicon-check';
    return 'glyphicon glyphicon-unchecked';
}

function createListItems(levels, selectedValues) {
    return levels.map((b) => ({
        isChecked: selectedValues.indexOf(b.value) >= 0,
        title: b.title,
        value: b.value
    }));
}

function areAllChecked(listItems) {
    var anyChecked = false;
    var allChecked = true;
    listItems.forEach(function (item, index) {
        if (item.isChecked === true) anyChecked = true;
        else allChecked = false;
    });
    return allChecked ? true : anyChecked ? null : false;
}

//https://stackoverflow.com/questions/53368828/refs-for-dynamically-generated-components-in-react
function boxKeyPressed(e) {
    var vm = this;
    if (
        e.keyCode === common.keyCodes.ArrowDown &&
        vm.allCheckboxes.length > 0
    ) {
        vm.allCheckboxes[0].elm.focus();
        e.preventDefault();
    }

    // switch (e.key) {
    //     // case ' ':
    //     //     vm.itemClicked(vm.selectedItem);
    //     //     e.preventDefault();
    //     //     break;
    //     case 'ArrowDown':
    //         //window.aaa = vm.allCheckboxes[0];
    //         if (vm.allCheckboxes.length > 0) vm.allCheckboxes[0].elm.focus();
    //         //vm.allCheckboxes[0].elm.childNodes[0].focus();
    //         // if (vm.selectedItem + 1 < vm.listItems.length)
    //         //     vm.selectedItem = vm.selectedItem + 1;
    //         e.preventDefault();
    //         break;
    //     // case 'ArrowUp':
    //     //     if (vm.selectedItem >= 0) vm.selectedItem = vm.selectedItem - 1;
    //     //     e.preventDefault();
    //     //     break;
    //     default:
    //}
}

function checkboxKeyPressed(e) {
    var vm = this;

    switch (e.keyCode) {
        case common.keyCodes.Tab:
            e.preventDefault();
            break;
        case common.keyCodes.ArrowDown:
            if (vm.allCheckboxes.length > 0) {
                const checkboxesWithIndex = vm.allCheckboxes.map((c, i) => ({
                    target: c.elm,
                    i
                }));

                const selectedCheckboxes = checkboxesWithIndex.filter(
                    (c) => c.target === e.target
                );

                const lastCheckboxIndex = vm.allCheckboxes.length - 1;
                const s = selectedCheckboxes[0];
                if (s.i < lastCheckboxIndex) {
                    vm.allCheckboxes[s.i + 1].elm.focus();
                    e.preventDefault();
                }
                break;
            }
    }
    // if (e.keyCode === common.keyCodes.Tab) {
    // }
    // if (
    //     e.keyCode === common.keyCodes.ArrowDown &&
    //     vm.allCheckboxes.length > 0
    // ) {
    // }

    // switch (e.key) {
    //     // case ' ':
    //     //     vm.itemClicked(vm.selectedItem);
    //     //     e.preventDefault();
    //     //     break;
    //     case 'ArrowDown':
    //         //window.aaa = vm.allCheckboxes[0];
    //         if (vm.allCheckboxes.length > 0) vm.allCheckboxes[0].elm.focus();
    //         //vm.allCheckboxes[0].elm.childNodes[0].focus();
    //         // if (vm.selectedItem + 1 < vm.listItems.length)
    //         //     vm.selectedItem = vm.selectedItem + 1;
    //         e.preventDefault();
    //         break;
    //     // case 'ArrowUp':
    //     //     if (vm.selectedItem >= 0) vm.selectedItem = vm.selectedItem - 1;
    //     //     e.preventDefault();
    //     //     break;
    //     default:
    //}
}

function keyHandler(e) {
    var vm = this;
    e.preventDefault();
    //if (e.type === 'keydown' && (e.code === 'Enter' || e.code === 'Space'))
    if (e.type !== 'keydown') return;
    if (
        e.keyCode === common.keyCodes.Enter ||
        e.keyCode === common.keyCodes.Space
    ) {
        if (e.target === vm.$refs.runReport) vm.runReport();
        else checkForClose(vm.messageType, e.target, vm.$refs);
    } else if (
        e.keyCode === common.keyCodes.Tab ||
        e.keyCode === common.keyCodes.ArrowRight ||
        e.keyCode === common.keyCodes.ArrowUp ||
        e.keyCode === common.keyCodes.ArrowLeft ||
        e.keyCode === common.keyCodes.ArrowDown
    ) {
        if (e.target === vm.$refs.goBack) vm.$refs.runReport.focus();
        else if (e.target === vm.$refs.runReport) vm.$refs.goBack.focus();
    }
}

function itemClicked(itemIndex) {
    var vm = this;
    var item = itemIndex === -1 ? vm.parent : vm.listItems[itemIndex];

    if (item.isChecked === true) {
        item.isChecked = false;
        if (itemIndex === -1)
            vm.listItems.forEach((item) => (item.isChecked = false));
    } else {
        item.isChecked = true;
        if (itemIndex === -1)
            vm.listItems.forEach((item) => (item.isChecked = true));
    }
    if (itemIndex >= 0) vm.parent.isChecked = areAllChecked(vm.listItems);
    vm.updateModel();
    vm.selectedItem = itemIndex;
}

function updateModel() {
    var vm = this;
    var newValue = [];
    vm.listItems.forEach(function (item, index) {
        if (item.isChecked === true) newValue.push(item.value);
    });
    vm.$emit('input', newValue);
}
</script>

<style scoped>
@media (max-width: 767px) {
    .checkbox-list {
        height: inherit;
    }
}
@media (min-width: 768px) {
    .checkbox-list {
        height: 126px;
        max-height: 126px;
        resize: none;
        overflow-y: scroll;
    }
}

.checkbox-list {
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
    background-color: white;
    padding: 5px 5px 5px 5px;
    display: block;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    -webkit-transition: border-color ease-in-out 0.15s,
        -webkit-box-shadow ease-in-out 0.15s;
    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    cursor: pointer;
}
@media (max-width: 767px) {
    .checkbox-list[data-v-1ebcd844] {
        height: inherit;
    }
}

.checkbox-list:focus div.blue-active {
    border: 1px solid rgb(161, 192, 216);
}

.parent-check-box,
.item-check-box {
    cursor: pointer;
    line-height: 22px;
    color: darkslategrey;
    padding: 0 4px 0 4px;
}

/*.item-check-box {
    margin-left: 4px;
  }*/

.glyphicon {
    margin-right: 4px;
}

/*.glyphicon.glyphicon-check {
    margin-left: -4px;
  }*/

/*.a-check-box.unchecked::before {
    content: '□';
    font-size: larger;
  }

  .a-check-box.indeterminate::before {
    content: '△';
    font-size: larger;
  }

  .a-check-box.checked::before {
    content: '■';
    font-size: larger;
  }*/

/*.book__chapter {
    display: block;
    position: reletive;
    margin-left: 40px;
  }*/
</style>
